import * as React from 'react';
import WebGLDirector from '../../webGL/WebGLDirector';
import GLComponent from './GLComponent';
import WebGLText from '../../webGL/WebGLText';
import WebGLLine from '../../webGL/shapes/primitives/WebGLLine';
import WebGLTextOrientation from '../../webGL/WebGLTextOrientation';
import WebGLLineStrip from '../../webGL/shapes/primitives/WebGLLineStrip';
import MathComponent from '../../shared/MathComponent';
import WebGLPolygon from '../../webGL/shapes/primitives/WebGLPolygon';
import WebGLArrow from '../../webGL/shapes/composites/WebGLArrow';

export default class Angles3Component extends GLComponent {

	public constructor () {
		super();
		this.heightFactor = 1 / 4;
	}

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.width, this.props.height, this.textOverlay);

		director.addShape(WebGLArrow.fromNumbers(-.8, -.1, -.4, 0));
		director.addShape(WebGLArrow.fromNumbers(-.4, 0, -.8, -.1));

		director.addShape(WebGLArrow.fromNumbers(-.8, 0, -.4, .1));
		director.addShape(WebGLArrow.fromNumbers(-.4, .1, -.8, 0));

		director.addText(new WebGLText('Parallel', -.7, -.1, WebGLTextOrientation.BOTTOM_RIGHT));

		director.addShape(WebGLArrow.fromNumbers(-.2, 0, .2, .1));
		director.addShape(WebGLArrow.fromNumbers(.2, .1, -.2, 0));

		director.addShape(WebGLArrow.fromNumbers(-.2, .1, .2, 0));
		director.addShape(WebGLArrow.fromNumbers(.2, 0, -.2, .1));

		director.addText(new WebGLText('Not parallel', -.15, -.1, WebGLTextOrientation.BOTTOM_RIGHT));

		director.addShape(WebGLArrow.fromNumbers(.5, -.1, .7, .1));
		director.addShape(WebGLArrow.fromNumbers(.7, .1, .5, -.1));

		director.addShape(WebGLArrow.fromNumbers(.5, .1, .7, -.1));
		director.addShape(WebGLArrow.fromNumbers(.7, -.1, .5, .1));

		director.addText(new WebGLText('Perpendicular', .425, -.1, WebGLTextOrientation.BOTTOM_RIGHT));

		director.drawScene();
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/lesson/WebGL/Angles3Component.tsx